// extracted by mini-css-extract-plugin
export var button = "_ks-0";
export var donut = "_ks-1";
export var donutFill = "_ks-3";
export var donutTrack = "_ks-2";